import AppRoute from './AppRoute';

export default AppRoute;
